module.exports = __webpack_public_path__ + "img/RegisterDaugther.d43966ab.png";